import { useEffect, useState } from 'react'
import { fetchDeployedBuildId } from './deployedVersion'

export const VERSION_POLL_INTERVAL_MS = 60_000

export type DeployedUpdateOptions = {
  buildId: string | null
  enabled: boolean
  fetchImpl?: typeof fetch
}

export const useDeployedUpdate = ({ buildId, enabled, fetchImpl }: DeployedUpdateOptions): string | null => {
  const [deployedBuildId, setDeployedBuildId] = useState<string | null>(null)

  useEffect(() => {
    if (!enabled || buildId === null || deployedBuildId !== null) return
    const controller = new AbortController()

    const check = async () => {
      if (document.visibilityState !== 'visible') return
      const deployed = await fetchDeployedBuildId(controller.signal, fetchImpl)
      if (controller.signal.aborted || deployed === null || deployed === buildId) return
      setDeployedBuildId(deployed)
    }

    const onVisibilityChange = () => void check()
    void check()
    const timer = setInterval(() => void check(), VERSION_POLL_INTERVAL_MS)
    document.addEventListener('visibilitychange', onVisibilityChange)

    return () => {
      controller.abort()
      clearInterval(timer)
      document.removeEventListener('visibilitychange', onVisibilityChange)
    }
  }, [buildId, deployedBuildId, enabled, fetchImpl])

  return deployedBuildId
}
